import React, { forwardRef } from 'react';

function CommentBoxParent({ ref, open, children }) {
  return (
    <div
      className={`modal fade uploaddialogfade reportdialog ${open ? 'show' : ''}`}
      style={open ? { display: 'block' } : {}}
      id="CommentDropBoxModal"
      tabIndex="-1"
      aria-labelledby="CommentDropBox"
      aria-hidden="true"
      ref={ref}
    >
      {children}
    </div>
  );
}

export default forwardRef((props, ref) => <CommentBoxParent ref={ref} {...props} />);
